import api from "./api"

const cleanParams = (params = {}) => {
  const clean = {}

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      clean[key] = value
    }
  })

  return clean
}

export const getSalesFormData = async (storeId = null, options = {}) => {
  const params = cleanParams({
    store_id: storeId,
    product_search: options.productSearch,
  })

  const response = await api.get("/sales/form-data", { params })
  return response.data
}

export const getSales = async (params = {}) => {
  const response = await api.get("/sales", { params: cleanParams(params) })
  return response.data
}

export const getSaleById = async (saleId) => {
  if (!saleId) {
    throw new Error("saleId is required")
  }

  const response = await api.get(`/sales/${saleId}`)
  return response.data
}

export const createSale = async (saleData) => {
  const response = await api.post("/sales", saleData)
  return response.data
}
